import { timestamp } from '@/helpers/dateTime';

export enum ScheduleStatus {
  ACTIVE = 'active',
  COMING_SOON = 'comingSoon',
  FINISHED = 'finished',
}

export const getStatusByTimeRange = (
  from: string,
  to: string
): [number, ScheduleStatus] => {
  const now = timestamp();

  const fromTs = timestamp(from);
  const toTs = timestamp(to);

  if (fromTs < now && now < toTs) {
    return [toTs - now, ScheduleStatus.ACTIVE];
  }

  if (now < fromTs) {
    return [fromTs - now, ScheduleStatus.COMING_SOON];
  }

  return [0, ScheduleStatus.FINISHED];
};
